<app-layout>
  <div class="px-[0.88rem] md:pt-[4.5rem]" primary>
    @if (response && response.surveyTitle) {
      <h1
        class="font-normal text-[2.5rem] text-inherit mb-6"
        [innerHTML]="response.surveyTitle | safeHtml"
      ></h1>
    }

    @if (gotoPageView) {
      <section role="region" aria-labelledby="gotopage-header">
        <h2 id="gotopage-header" class="text-inherit font-normal">
          {{ "gotopage.header" | translate }}
        </h2>

        @if (gotoPageView.data.gotoPageReason === "ALTERNATIVE_QUOTA") {
          <div class="mt-6 p-4 quota-alert" role="alert">
            <p id="gotopage-quota-explanation">
              {{ "gotopage.quota.explanation" | translate }}
            </p>
          </div>
        }

        <p class="mt-6" id="gotopage-whattodo">
          {{ "gotopage.whattodo" | translate }}
        </p>

        <app-button
          class="mt-6 btn-gotopage-primary"
          buttonId="gotopage-btn"
          (buttonClick)="startOver(startOverUrl)"
          [buttonText]="'gotopage.startfrombeginning.button' | translate"
          [buttonType]="'button'"
          [describedBy]="'gotopage-whattodo'"
        ></app-button>
      </section>
    }
  </div>

  <app-navigation
    (nextClick)="startOver(continueUrl)"
    [nextButtonText]="'gotopage.continue.button' | translate"
    navigation
  ></app-navigation>

  @if (chooseLanguageComponent) {
    <app-choose-language
      appLanguage
      class="mr-2 lg:mr-4"
      [showFlags]="chooseLanguageComponent.showFlags"
      (selectedLanguage)="setLanguage($event)"
      [defaultLanguage]="response.language"
      [options]="languageOptions"
      [translationKeys]="['gotopage.']"
      [fallbackLanguage]="response.fallbackLanguage"
    ></app-choose-language>
  }
</app-layout>
